<template>
  <div class="flex flex-row items-center my-1 lg:my-2 xl:my-4 text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl uppercase">
    <h1>{{ text }}</h1>
    <template v-if="logo === true">
      <div class="ml-1 md:ml-2 lg:ml-4">''</div>
      <img class="h-4 sm:h-6 md:h-8 lg:h-10 xl:h-12" src="@/assets/logo.png" alt="EASY" />
      <div>''</div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    text: {
      type: String,
      required: true,
    },
    logo: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
